import axios from 'axios';

const client = axios.create({
  baseURL: '/api/v1',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to login on auth failure, but not for the /auth/me endpoint
      if (!error.config?.url?.includes('/auth/me')) {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default client;
